import { Injectable } from '@angular/core';
import { TENENTS } from 'src/environments/tenent.data';

export interface TenantData {
  "name": string,
  "propertyId": string,
  "template": string,
  "templateTheme": string
}

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  getTenantForHostname(hostname: string): TenantData {
    const tenentData = TENENTS.find(entry => entry.name.includes(hostname));
    return tenentData;
  }

  public getTenant(): TenantData {
    return this.getTenantForHostname(location.hostname.replace('www.',''));
  }
}